export default __webpack_public_path__ + "static/media/muv.8ea74c41.svg";